import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This ensures smooth scrolling
    });
  };
  return (
    <footer className="bg-blue-900 text-white py-1 mt-10">
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-6 mt-10" >
        {/* Column 1 */}
        <div>
          <h2 className="text-4xl font-bold mb-12 ">ApplicationUni</h2>
          <p className="text-sm leading-relaxed">
            DSM 439, 4th Floor,<br />
            DLF Towers, Shivaji Marg,<br />
            Moti Nagar, New <br />
             Delhi,110015, India

          </p>
          <br />
          <p className="text-sm leading-relaxed">
          2007, Marina Pear Business Center, <br />
          Trade Center, Sheikh Zayed Road, Dubai,<br />
          United Arab Emirates

          </p>
          <p className="text-sm leading-relaxed mt-8 font-semibold">
            info@applicationuni.com <br />
            www.applicationuni.com
          </p>
          
        </div>

        {/* Column 2 */}
        <div>
        <h3 className="text-lg font-bold mb-3 ">Our Trips</h3>
          
          <ul>
          <li>
        <Link to="/tours/london-tour" className="hover:underline" onClick={scrollToTop}>
          London Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/australia-tour" className="hover:underline" onClick={scrollToTop}>
          Australia Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/dubai-tour" className="hover:underline" onClick={scrollToTop}>
          Dubai Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/usa-tour" className="hover:underline" onClick={scrollToTop}>
          US NASA Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/united-nations-tour" className="hover:underline" onClick={scrollToTop}>
          UN Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/singapore-tour" className="hover:underline" onClick={scrollToTop}>
          Singapore Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/japan-tour" className="hover:underline" onClick={scrollToTop}>
          Japan Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/south-korea-tour" className="hover:underline" onClick={scrollToTop}>
          South Korea Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/spain-tour" className="hover:underline" onClick={scrollToTop}>
          Spain Trip
        </Link>
      </li>
      <li>
        <Link to="/tours/silicon-valley-tour" className="hover:underline" onClick={scrollToTop}>
          Silicon Valley Trip
        </Link>
      </li>
          </ul>
          
        </div>

        {/* Column 3 */}
        <div>
          <h3 className="text-lg font-bold mb-3">About</h3>
          <Link to='/aboutus' onClick={scrollToTop}>
          <ul>
            <li>
              <a href="#" className="hover:underline">
                Our Story
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Our Vision
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Our Journey
              </a>
            </li>
            
          </ul>
          </Link>
          <h3 className="text-lg font-bold mt-6 mb-3">Contact Us</h3>
          <ul>
            <Link to='/contact' onClick={scrollToTop}>
            <li>
              <a href="#" className="hover:underline">
                Contact Form
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
              Our Location
              </a>
            </li>
            </Link>
            
          </ul>

          
        </div>

        {/* Column 4 */}
        <div>
          <h3 className="text-lg font-bold mb-3">Destinations</h3>
          <Link to='/destination' onClick={scrollToTop}>
          <ul>
            <li>
              <a href="#" className="hover:underline">
                Summer Schools
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Past Tours
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Testimonials
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                Impacts
              </a>
            </li>
          </ul>
          </Link>
          <h3 className="text-lg font-bold mt-6 mb-3">Programs</h3>
          <ul>
            <Link to="/programs" onClick={scrollToTop}>
            <li>
              <a href="#" className="hover:underline">
                Partner Universities
              </a>
            </li>
            <li>
              <a href="#" className="hover:underline">
                FAQs
              </a>
            </li>
            {/* <li>
              <a href="#" className="hover:underline">
                Accessibility
              </a>
            </li> */}
            <li>
              <a href="#" className="hover:underline">
               AI eligibility Checker
              </a>
            </li>
            </Link>
          </ul>
        </div>
      </div>
      {/* Copyright */}
      <div className="text-right mt-0 text-sm mr-10">
        © 2024-2025 ApplicationUni Inc.
      </div>
    </footer>
  );
};

export default Footer;
